import {
    get,
    post,
    execute
} from "../axios";


/**
 * 获取某个商品信息
 * @param {mixSerNo,mixId}
 * @return {Promise} 
 */
export const GetGoodsMixBasicInfo = data => execute('eshopapi/v1/GoodsDetail/GetGoodsMixBasicInfo', data)

/**
 * 获取某个商品规格参数
 * @param {mixSerNo,mixId}
 * @return {Promise} 
 */
export const GetGoodsMixPropInfo = data => execute('eshopapi/v1/GoodsDetail/GetGoodsMixPropInfo', data)

/**
 * 预览页面 规格参数
 * @param {mixSerNo,mixId}
 * @return {Promise} 
 */
export const GetGoodsMixPropInfoForEdit = data => execute('eshopapi/v1/GoodsDetail/GetGoodsMixPropInfoForEdit', data)

/**
 * 获取预览商品信息
 * @param {mixSerNo,mixId}
 * @return {Promise} 
 */
export const GetGoodsMixBasicInfoForEdit = data => execute('eshopapi/v1/GoodsDetail/GetGoodsMixBasicInfoForEdit', data)

/**
 * 获取相似风格商品
 * @param {mixSerNo,mixId}
 * @return {Promise} 
 */
export const GetGoodsMixLikeInfo = data => execute('eshopapi/v1/GoodsDetail/GetGoodsMixLikeInfo', data)

/**
 * 获取省市列表
 * @param {}
 * @return {Promise} 
 */
export const GetProvinceAndCityList = () => execute('EShopApi/v1/GoodsDetail/GetProvinceAndCityList')

/**
 * 获取区县乡镇列表
 * @param {cityCode}
 * @return {Promise} 
 */
export const GetDistrictTownList = data => execute('EShopApi/v1/GoodsDetail/GetDistrictTownList', data)

// /**
//  * 获取分类基本信息
//  * @param {spaceId}
//  * @return {Promise} 
//  */
// export const GetSearchInfoList = data => execute('eshopapi/v1/GoodsSearch/GetSearchBasicInfo', data)

// /**
//  * 获取商品分类列表
//  * @param {data}
//  * @return {Promise} 
//  */
// export const GetGoodsPageList = data => execute('eshopapi/v1/GoodsSearch/GetMixSearchPageList', data)

/**
 * 获取分类页属性（新）
 * @param {data}
 * @return {Promise} 
 */
export const GetSearchBasicInfoList = data => execute('eshopapi/v1/GoodsSearchProp/GetSearchBasicInfo', data)

/**
 * 获取查询到的商品（新）
 * @param {data}
 * @return {Promise} 
 */
export const GetMixSearchGoodsList = data => execute('eshopapi/v1/GoodsSearchProp/GetMixSearchPageList', data)

/**
 * 获取商品服务费信息
 * @param {data}
 * @return {Promise} 
 */
export const GetGoodsMixServiceFee = data => execute('eshopapi/v1/GoodsDetail/GetGoodsMixServiceFee', data)

/**
 * 获取商品服务费信息（新）
 * @param {data}
 * @return {Promise} 
 */
export const GetGoodsMixServiceFeeNew = data => execute('eshopapi/v1/GoodsDetail/GetGoodsMixServiceFee_New', data)

/**
 * 热销排行 TOP3
 * @param {data}
 * @return {Promise} 
 */
export const GetHotRankTop3 = data => execute('eshopapi/v1/GoodsSearchTag/GetTopThreeList', data)
/**
 * 热销排行 列表
 * @param {data}
 * @return {Promise} 
 */
export const GetHotRankList = data => execute('eshopapi/v1/GoodsSearchTag/GetMixSearchPageList', data)
/**
 * 获取商品采购价
 * @param {data}
 * @return {Promise} 
 */
export const GetGoodsMixTradePrice = data => execute('eshopapi/v1/GoodsDetail/GetGoodsMixTradePrice', data)
/**
 * 获取采购价（密码认证）
 * @param {data}
 * @return {Promise} 
 */
export const GetGoodsMixTradePricePwd = data => execute('eshopapi/v1/GoodsDetail/GetGoodsMixTradePricePwd', data)
/**
 * 获生成商品详情二维码
 * @param {data}
 * @return {Promise} 
 */
export const GetMiniGoodsQrCode = data => execute('eshopapi/v1/GoodsDetail/GetMiniGoodsQrCode', data)